import { get } from 'lodash';
import { IM_PAYING_MYSELF } from '@zocdoc-frontend-common/components-insuranceform';
import { BookingStateProperties } from '../constants';

export const insuranceValidForCheckingAcceptance = (bookingState = {}) => {
    return (
        get(
            bookingState,
            [BookingStateProperties.insuranceCarrierId],
            IM_PAYING_MYSELF
        ) !== IM_PAYING_MYSELF &&
        parseInt(
            get(bookingState, [BookingStateProperties.insurancePlanId], 0),
            10
        ) > 0
    );
};
